import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';

const StockCostCreate = ({open, close, model, ...rest}) => {
  const app = React.useContext(AppContext)
  const { products } = app.products
  const AmazonSalesChannel = React.useContext(SalesChannelsContext)
  const { recall, setRecall } = AmazonSalesChannel
  const { create, update } = AmazonSalesChannel.externalwarehousingCosts

  const submit = model?update:create
  const title = model?"Actualizar":"Añadir"
  const product = model? products.find(p => p.id == model.productId): null
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <ObjectForm sx={{minHeight: '700px'}} ignored={['id']} recall={recall} submit={create}
        stc={{ vendor: app.vendor }}
        obj={model || {date:'', productId:'', cost:'',}}
        labels={{date:'Fecha', productId:'Producto', cost:'Costo',}}
        types={{date:'date', productId:'select-search', cost:'money', }}
        options={{productId:products.map(p => {return{value:p.id,label: `${p.asin} - ${p.sku}`}})}} 
        controlled={{cost:model?model.cost:0, date:model?model.date:null}}
        changed={{...model, productId:product?product.id:null} || {}} 
      />
      <Button onClick={() => {setRecall(true);close()}}>{title}</Button>
    </Dialog>
  )
}
export default StockCostCreate